import { useQuery } from '@tanstack/react-query';

import { ActiveStayPeriod } from 'src/features/stay/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/visitors/past-stay/:stayId/past-stay-period/:periodId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    stayId: string;
    periodId: string;
}
const queryFn = ({ stayId, periodId, parkingId, ...params }: DTO): Promise<ActiveStayPeriod> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, stayId, periodId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as PAST_STAY_PERIOD_RESOURCE, useQueryHook as useGetPastStayPeriod };
